/* ═══════════════════════════════════════════════════════════════════════════
   💬 src/services/useCommentPages.js — the twin of the phone's hook: one post's
   comment pages, live, for an open thread. Subscribes to the tab's pager
   (services/vibeCommentApi) and keeps it in
   step with the post: the first page when the sheet opens, what is new when
   the post's counter moves. Pass `null` while no sheet is open.
   🟥 READ FROM THE PAGER ON EVERY RENDER, never held in local state: a copy
      held across a change of post shows the LAST post's comments for a frame.
   ═══════════════════════════════════════════════════════════════════════════ */
import { useEffect, useState } from 'react';
import { commentPager } from './vibeCommentApi';
import { commentCountOf } from './vibeComments';
import { isPagedPost, emptyPages } from './commentPages';

/* one empty answer for "no thread open" — a fresh object every render would
   re-run every effect that depends on the pages */
const EMPTY = emptyPages();

export function useCommentPages(post, sort) {
  const id = post && post.id ? String(post.id) : '';
  const [, bump] = useState(0);
  useEffect(() => {
    if (!id) return undefined;
    return commentPager.subscribe(() => bump((n) => (n + 1) % 1e9));
  }, [id, sort]);
  const state = id ? commentPager.get(id, sort) : EMPTY;
  const paged = isPagedPost(post);
  const count = post ? commentCountOf(post) : 0;
  useEffect(() => {
    if (!id || !paged) return;
    commentPager.sync(post, sort);
  }, [id, sort, paged, count, state.ready, state.loading]); // eslint-disable-line react-hooks/exhaustive-deps
  return state;
}
